export default {
  TitleProcess: 'Nghiệp vụ Kho bạc điện tử',
  TitleProcessRight: 'Kết nối DVC',
  TitleKBNN: 'KHO BẠC NHÀ NƯỚC',
  Description: 'Tính năng kết nối Kho bạc điện tử không cần xuất file và nhập khẩu thủ công vào DVC',
  FileName: 'Đăng ký sử dụng ứng dụng, dịch vụ của kho bạc nhà nước.doc',
  TabItem: {
    Process: {
      Title: 'Quy trình',
      TabKey: 'process',
    },
    DVCFile: {
      Title: 'Hồ sơ thanh toán',
      TabKey: 'dvcfile',
      Command: 'DVCFileTab',
      CommandDetail: 'DVCFileDetail',
    },
    DCSDFile: {
      Title: 'Hồ sơ đối chiếu',
      TabKey: 'dcsdfile',
      Command: 'DCSDFileTab',
      CommandDetail: 'DCSDFileDetail',
    },
  },
  TitleMessage: {
    Invalid: 'Không hợp lệ',
    NoDelete: 'Không thể xóa',
    NoEdit: 'Không thể sửa',
  },
  Message: {
    ViewInstruction: 'Xem hướng dẫn',
    RequestLoginToConnect: 'Bạn vui lòng đăng nhập để thực hiện chức năng tại màn hình Kết nối KBNN',
    AlertConnectDVC: 'Bạn cần kết nối DVC để thực hiện chức năng này',
    ConnectSuccess: 'Đăng nhập thành công',
    DisconnectSuccess: 'Hủy kết nối thành công',
    ConnectFail: 'Đăng nhập không thành công',
    BadLogin: 'Thông tin đăng nhập không chính xác. Vui lòng nhập lại.',
    ErrorLogin:
      'Đăng nhập không thành công. Vui lòng nhập đúng thông tin tài khoản và mật khẩu đăng nhập trên Dịch vụ công của KBNN, hoặc đăng ký kết nối trực tuyến với KBNN. Xem hướng dẫn <a {0}>tại đây</a>.',
    Disconnect: 'Đã ngắt kết nối',
    Connect: 'Kết nối',
    nameKb: 'Kho bạc điện tử DVC',
    InforLogin: 'Nộp trực tiếp hồ sơ cho Kho bạc nhà nước và tự động hạch toán',
    KBNNDescription:
      'Áp dụng tính năng kết nối <b>Kho bạc điện tử</b> Gửi hồ sơ trực tiếp không cần xuất file và nhập khẩu thủ công vào VDC',
    CaseNotRegister: 'Nếu chưa đăng ký với Kho bạc, anh/chị tải phiếu đăng ký',
    Here: ' tại đây ',
    EndTextCaseNotRegister: ' và nộp ',
    EndText: ' cho Kho bạc nơi giao dịch.',
    Intruct: 'Hướng dẫn',
    HeadOfDepartmentInvalid:
      'Tính năng này không áp dụng khi đăng nhập Kho bạc điện tử với vai trò Chủ tài khoản. Vui lòng đăng nhập với tài khoản kế toán viên hoặc kế toán trưởng.',
    AriseDvcFile: '<b>{0} - {1}</b> đã có phát sinh hồ sơ Kho bạc điện tử. Vui lòng kiểm tra lại.',
    WarrinBudgetCodeOther:
      'Mã QHNS kết nối kho bạc nhà nước đang khác với mã đơn vị trên Bảng kê nội dung thanh toán/tạm ứng. Vui lòng Chuyển đơn vị giao dịch với KBNN.',
  },

  Action: {
    CreateDVCFile: 'lập hồ sơ',
    AcceptDVCFile_1: 'Kế toán trưởng',
    AcceptDVCFile_2: 'duyệt hồ sơ',
    HeadAccept_1: 'Thủ trưởng',
    HeadAccept_2: 'ký duyệt',
    SendKBNN_1: 'Nộp Kho bạc',
    SendKBNN_2: 'Nhà nước',
    Disconnect: 'Ngắt kết nối',
    Connect: 'Kết nối',
    AddBudget: 'Thêm ĐVQHNS/ Dự án',
    ConnectDVC: 'Kết nối DVC',
  },

  LoginForm: {
    BudgetCode: 'Mã QHNS',
    Username: 'Tên đăng nhập',
    Password: 'Mật khẩu',
    Account: 'Tài khoản',
    Role: 'Vai trò',
  },

  DvcBudgetDetail: {
    BudgetCode: 'Mã ĐVQHNS/ Dự án',
    BudgetName: 'Tên ĐVQHNS/ Dự án',
  },
};
